import * as Yup from 'yup';

export default Yup.object().shape({
  amount: Yup.number().typeError('amount invalid').required('amount required'),
});
